import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const getEntryForFirm = (state, firmId) => state.find((rec) => rec.referralFirmId === firmId);
const getEntriesForOtherFirms = (state, firmId) => state.filter((rec) => rec.referralFirmId !== firmId);

export const orgContactsSlice = createSlice({
  name: 'orgContacts',
  initialState: initialState,
  reducers: {
    clearOrgContacts: () => {
      return initialState;
    },

    setVisibleFirmsWithContacts: (state, action) => {
      return action.payload;
    },

    addVisibleFirmWithContacts: (state, action) => {
      const { visibleFirmId, contactIdsArray } = action.payload;
      const existingEntry = getEntryForFirm(state, visibleFirmId);
      if (existingEntry) {
        const otherEntries = getEntriesForOtherFirms(state, visibleFirmId);
        const modifiedEntry = { ...existingEntry, contactIds: contactIdsArray };
        return [...otherEntries, modifiedEntry];
      } else {
        const newStruct = {
          referralFirmId: visibleFirmId,
          contactIds: contactIdsArray,
        };
        return [...state, newStruct];
      }
    },

    addVisibleFirmContact: (state, action) => {
      const { visibleFirmId, contactId } = action.payload;
      const existingEntry = getEntryForFirm(state, visibleFirmId);
      if (existingEntry) {
        // We have a list of contacts for that firm. Add (if missing) the new contact Id
        const existingList = existingEntry.contactIds;
        if (existingList.indexOf(contactId) < 0) {
          // missing
          const newList = [...existingList, contactId];
          const newEntry = {
            referralFirmId: visibleFirmId,
            contactIds: newList,
          };
          const otherEntries = getEntriesForOtherFirms(state, visibleFirmId);
          return [...otherEntries, newEntry];
        } else {
          // already have this contact listed.  No need to do anything
          return state;
        }
      } else {
        // Don't yet have record of any contacts at this firm
        const newEntry = {
          referralFirmId: visibleFirmId,
          contactIds: [contactId],
        };
        return [...state, newEntry];
      }
    },

    removeVisibleFirmContact: (state, action) => {
      const { visibleFirmId, contactId } = action.payload;
      const existingEntry = getEntryForFirm(state, visibleFirmId);
      if (existingEntry) {
        const prevContactIds = existingEntry.contactIds;
        if (prevContactIds.indexOf(contactId) < 0) {
          return state;
        }
        const prunedContactIds = prevContactIds.filter((id) => id !== contactId);
        const prunedEntry = { referralFirmId: visibleFirmId, contactIds: prunedContactIds };
        const otherEntries = getEntriesForOtherFirms(state, visibleFirmId);
        return [...otherEntries, prunedEntry];
      } else {
        return state;
      }
    },

    removeVisibleFirm: (state, action) => {
      return getEntriesForOtherFirms(state, action.payload);
    },

    bulkChangeOrgContactOwnerships: (state, action) => {
      // we're hoping that this is accompanied by a call on bulkChangeClientOwnerships,
      // which will do the changing of the person records to have the new owner
      return state;
    },
  },
});

export const {
  clearOrgContacts,
  setVisibleFirmsWithContacts,
  addVisibleFirmWithContacts,
  addVisibleFirmContact,
  removeVisibleFirmContact,
  removeVisibleFirm,
  bulkChangeOrgContactOwnerships,
} = orgContactsSlice.actions;

export default orgContactsSlice.reducer;
